import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getVarietiesPhyto.success: {
            return action.payload;
        }

        case constants.getVarietiesPhyto.error: {
            return initialState;
        }

        case constants.getVarietiesPhyto.try: {
            return {};
        }

        default:
            return state;
    }
}